
import ctrlMixins from './../_mixins.js';
import { UarmCtrlComponent, CardMetaItem, UarmCtrlComponentMeta } from './../../types';
import { ctrlParamsForAll } from './../_common-stuff.ts';
// @ts-ignore
import Geocoder from './geocoder.vue';
// @ts-ignore
import { defaultZoom, defaultCenter as homeCenter, epsg3857toEpsg4326, geomixins } from './geocommon.ts';

const meta: UarmCtrlComponentMeta = {
	// это наши данные, т.е. вуй при объявлении компонента их не использует
	title: 'Интерактивная карта ГИП',
	// tip: 'Данные хранятся в формате YandexJSON (описание формата см. в функцииya2geo), а для применения в ГИП конвертируются в формат GeoJSON',
	params: {
		...ctrlParamsForAll,
	},
}

// Vue.extend нельзя! будут ошибки с $attrs и $listeners
export default {
	name: 'ctrl_geo_multi',
	mixins: [ctrlMixins, geomixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		/** Значение текущей колонки */
		value: {
			type: String,
			default: () => ('[]'),
		},
	},
	components: { Geocoder },
	meta,
	data: function () {
		return {
			errText: '',
			geoReadyHappened: false,
			mapId: `mapId-${Math.floor(Math.random() * 1e7)}`,
			geoServiceName: null,
			baseMapName: null,
			geoApi: null,
			// индекс точки, координаты которой мы в данный момент редактируем кликом на карту
			// (т.е. ждем клика и из него задаем координаты)
			markCoordMapClickEditIndex: -1,
			colorList: [],
		}
	},
	methods: {
		/**
		 * Инициализация карты (собираем конфиг, вешаем события и т.п.)
		 * Запускается из миксина primaryInitMap
		 */
		initMap() {
			this.$data.geoApi = window['GeoportalApi']; // cloneDeep(window['GeoportalApi']);
			const { geoApi, mapId, geoServiceName, baseMapName } = this.$data;

			const mapConfig = {
				layersConfig: null, // {defaultLayers: [],requiredLayers: [],mainLayers: [],},
				homeCenter,
				homeZoom: this.valueYaJSON.zoom || defaultZoom,
				service: geoServiceName || null,
				baseMaps: baseMapName ? [baseMapName] : ['bk_pk_gip'], // gip_conf.base_map
				baseMapsList: ['basemap_rzd', 'bk_pk_gip'],
				workSetFitDisabled: false,
				workSetId: null, // например, 123
				interfaceConfig: { // можно вместо объекта передать налл
					isStatusBarHidden: true,
					isMainToolbarHidden: true,
					// hiddenTools: ['LAYER_LIST', 'MEASURE_CIRCLE'], // массив ключей инструментов, которые будут скрыты в MainToolbar
					isMapToolbarHidden: true, // правая панель
					isZoomHidden: false, // кнопки зума справа
				},
				// interfaceConfig: null,
			};

			// Инициализация геопортала. Передаётся идентификатор элемента и объект конфигурации
			geoApi.init(mapId, mapConfig);

			geoApi.ready = () => {
				this.$data.geoReadyHappened = true;
				console.log(`geo.ready`, mapConfig);

				// Пересчитать размеры карты - ??? зачем? что оно делает?
				geoApi.updateMapSize();

				this.resetAllMapMarks();

				// ОЦРВ сказали, что координаты по клику получаются только в системе 3857, конвертим сами
				geoApi.onMapClick = (coord, srCode) => {
					const coord3857 = epsg3857toEpsg4326(coord)

					this.$data.geoApi.getZoom((zoom) => {
						const { features } = this.valueGeoJSON;
						const clickedMark = getClickedMark(features, coord3857, zoom);

						// Кейс 1. Кликнули по точке. Выделяем её в списке как редактируемую
						if (clickedMark) {
							this.$notify(`${clickedMark.properties.hintContent}. Кликните по карте, чтобы задать новые координаты`);
							this.$data.markCoordMapClickEditIndex = features.findIndex(fe => fe.properties.markerId === clickedMark.properties.markerId);
							return
						}

						const clickIsAdding = this.$data.markCoordMapClickEditIndex < 0;
						if (clickIsAdding) {
							// Кейс 2. Кликнули по свободному месту и редактируемой точки нет. Добавляем новую.
							this.markAdd(coord3857);
						}
						else {
							// Кейс 3. правим локацию редактируемой точки. Редактируемой точка может стать либо при клике по точке либо при нажатии кнопки смены координат в списке
							const markToEdit = features[this.$data.markCoordMapClickEditIndex]
							markToEdit.geometry.coordinates = coord3857;
							this.resetAllMapMarks();
						}
						this.$data.markCoordMapClickEditIndex = -1;
						//this.setPoint(coord3857);
						//this.emitValue(coord3857);
					})

				};
			}
		},
		/**
		 * Проставляем на карте заново все точки из значения GeoJSON
		 */
		resetAllMapMarks() {
			if (!this.$data.geoReadyHappened) {
				console.log(`resetAllMapMarks вызван без geo ready, ничего не делаем`)
				return
			}
			const { geoApi } = this.$data;
			console.log(`resetAllMapMarks!`);
			// Манипуляции с зумом и условия по колву точек ниже - потому что showGeometry сам ставит зум
			// Если точек много это удобвно, так ставится зум который всё умещает
			// А вот если точка одна - поведение showGeometry неудобно, слишком сильно зумет
			// Поэтому в этом случае сохраняем текущий зум при добавлении (get в силу архитектуры асинхронный)
			// ...и выставляем - после
			// По хорошему ещё getExtent / setExtent применять, чтобы оно не скакало если новая точка близко к краю
			// Либо хотя бы первичн
			geoApi.getZoom((lastZoom) => {
				geoApi.clearGeometry();
				geoApi.showGeometry(this.valueGeoJSON);
				geoApi.setZoom(lastZoom);
			});
		},
		/**
		 * Добавляем feature
		 */
		markAdd(geoCoords) {
			const isSetFromMapClick = Array.isArray(geoCoords);
			const coordinates = isSetFromMapClick ? geoCoords : homeCenter.slice();
			if (!isSetFromMapClick) {
				this.$notify('Задайте координаты с помощью клика по карте');
			}
			this.valueGeoJSON.features.push({
				type: 'Feature',
				geometry: { type: 'Point', coordinates },
				properties: {
					markerId: Math.floor(Math.random() * 1e7),
					hintContent: `Новая точка ${Date.now()}`,
					address: '', // null у яндекса был
					phone: '', // null у яндекса был
					site: '', // null у яндекса был
					desc: '',
					color: this.$data.colorList[0],
				}
			})
			// this.markCoordMapClickEditIndex = this.valueGeoJSON.features.length - 1;
			this.resetAllMapMarks();
			this.updateCtrlValue();
		},
		/**
		 * Удаляем feature
		 * @param mark_i индекс
		 */
		markDel(mark_i) {
			this.valueGeoJSON.features.splice(mark_i, 1);
			this.resetAllMapMarks();
			this.updateCtrlValue();
		},
		/**
		 * Отправляем новые данные "наверх" для сохранения
		 */
		updateCtrlValue() {
			this.$data.geoApi.getZoom((zoom) => {
				const newYaValueForColumn = JSON.stringify(geo2ya(this.valueGeoJSON, zoom));
				console.log(`updateCtrlValue!`);
				this.c_value = newYaValueForColumn;
				this.mixin_inputEvent();
				/* this.mixin_inputEvent({
					ctrlCode: this.$props.field_meta.ctrlCode,
					dbcolname: this.$props.field_meta.dbcolname,
					evtType: 'set',
				}); */
				this.$emit('input', newYaValueForColumn);
				// this.$emit('input', this.c_value);
			})
		},
	},
	computed: {
		// На самом деле обёртка поверх c_value. По идее, можно просто пропс value снабдить дефолтным значением
		// Хочется рефакторить, но некогда :(
		valueYaJSON() {
			const yaDefaultCoords = [...homeCenter].reverse();
			// после окончательного выключения Яндекса можно не хранить ничего кроме markers и zoom
			// и возможно zoom + coords
			const yaDefaultVal = {
				coords: yaDefaultCoords,
				zoom: defaultZoom,
				markers: [],
				sortMode: null,
				sortField: null,
				settings: {
					apiKey: 'b0aed604-d757-4382-a232-bb84da1351ed',
					lang: 'ru_RU',
					coordorder: 'latlong',
					version: '2.1'
				},
			}
			// console.log(this.c_value, typeof this.c_value, this.c_value.length);
			const val = this.c_value ?
				// Вот эти риплейсы перетащены из старого контрола интерактивных карт с комментом
				// "допилить UARM на тему экранирования последней кавычки в ссылке CWP-16144".
				// Предстоит разобраться, из-за чего ломается парсинг, но вот этот трюк лечит, правда не всё,
				// а только один атрибут у ссылки, здесь вроде другого не бывает, но всё же по уму либо причину
				// устранить, либо в риплейсах сделать замену \" на \\", причём с контролем чтобы она не случилась
				// несколько раз (тогда кол-во бекслешей будет расти с каждым разом), то есть с negative lookbehind
				// JSON.parse(this.c_value.replace(/\\"/g, "'").replace(/">/g, "'>"))
				JSON.parse(this.c_value)
				: yaDefaultVal;
			return val;
		},
		valueGeoJSON: {
			get: function () {
				console.log(`valueGeoJSON: Get`);
				return ya2geo(this.valueYaJSON);
			},
			set: function (newValue) {
				console.log(`valueGeoJSON: computed setter`, newValue);
				this.$data.geoApi.getZoom((zoom) => {
					this.c_value = JSON.stringify(geo2ya(newValue, zoom));
				});
			},
		},
		colorListSharp() {
			return this.$data.colorList.map(col => `#${col}`)
		},
	},
	watch: {
		// работает фиг знает как, разобраться не успел, пришлось вот устроить кнопку Сохранить и руками вызывать this.resetAllMapMarks(); + this.updateCtrlValue();
		'valueGeoJSON.features': {
			deep: true,
			immediate: true,
			handler() {
				console.log(`valueGeoJSON.features watcher`);
				const { geoApi } = this.$data;

				if (geoApi) {
					this.resetAllMapMarks();
				}
			}
		}
	},
	mounted() {
		if (this.$props.view_type !== 'card') {
			this.mixin_errHandler(new Error(`Контрол реализован только для карточки`));
		}
		// проверка вот почему: в новой админке по ходу два раза инициализируется АРМ
		// и с такими контролами как этот или tinymce случаются проблема - mounted срабатывает дважды
		// надо бороться с первопричиной, но нет времени пока, так что вот проверка
		// на то, что элемент существует в DOM. Можно ещё использовать document.contains(this.$el)
		if (this.$el.isConnected) {
			this.primaryInitMap();
		}
		else {
			console.log(`Двойная инициализация контрола, а по всей видимости и всего инстанса. Пока что лечим костылём`);
		}
	},
}

/*
	++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
	TODO функции описанные брать на морде (rzd\front\src\js\entries\common\gip_map.js) и здесь из одного источника
	++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
*/

/**
 * Функция получения по клику либо точки, по которой кликнули, либо undefined, если кликнули в чисто поле
 * @param features список точек (массив features из GeoJSON)
 * @param coords координаты клика (долгота/широта в системе 4326)
 * @param zoom значение зума
 */
function getClickedMark(features, coords, zoom) {
	const precision = [
		0, 1, 0.8, 0.6, 0.25, 0.17, 0.1, 0.05, 0.02, 0.01, 0.005, 0.002, 0.0014, 0.0007, 0.0003, 0.00015, 0.00008, 0.00004,
		0.000014, 0.00001, 0.000005,
	];
	let map = features.map((point, indx, arr) => {
		let dif_lat = Math.abs(point.geometry.coordinates[1] - coords[1]);
		let dif_lng = Math.abs(point.geometry.coordinates[0] - coords[0]);
		return { id: indx, features: arr[indx], neighbour: (dif_lat + dif_lng) / 2 };
	}).sort((a, b) => a.neighbour - b.neighbour);
	if (map[0].neighbour < precision[Math.round(zoom)]) {
		return map[0].features;
	} else return;
};

/**
 * Конвертация формата GeoJSON в формат яндекса (его мы исторически храним в БД)
 */
function geo2ya(geojson, zoom = defaultZoom) {
	// console.log(`geo2ya: geojson=`, geojson);
	// geojson = { type: 'FeatureCollection', features: { type: 'Feature', geometry: { type: 'Point', coordinates: coords.slice().reverse() }, properties: { markerId, hintContent, address, phone, site, desc, color }, } }
	const markers = geojson.features.map(fe => {
		const { markerId, hintContent, address, phone, site, desc, color } = fe.properties;
		return {
			markerId, hintContent, address, phone, site, desc, color,
			coords: fe.geometry.coordinates.map(v => String(v)).reverse()
		} // разные порядок (ГИП: Д/Ш, Яндекс: Ш/Д), и тип (ГИП: число, Яндекс: строка)
	})
	return {
		coords: homeCenter.slice().reverse(), // широта/долгота, слайс чтобы не мутировать. TODO текущее значение центра карты
		zoom,
		markers,
		sortMode: null,
		sortField: null,
		settings: { // это и остальные поля оставлю тупо "как было" константами. Когда точно переедем на ГИП, можно будет прибить всё кроме markers
			apiKey: 'b0aed604-d757-4382-a232-bb84da1351ed',
			lang: 'ru_RU',
			coordorder: 'latlong',
			version: '2.1'
		}
	}
}
/**
 * Конвертация формата яндекса (его мы исторически храним в БД) в GeoJSON.
 */
function ya2geo(yajson) {
	// console.log(`ya2geo: yajson=`, yajson);
	// yajson = {"coords":[55.87015199998713,37.508885],"zoom":17,"markers":[{"markerId":1,"hintContent":"Грачёвская","coords":["55.870152","37.508885"],"address":null,"phone":null,"site":null,"desc":"","color":"E21A1A"}],"sortMode":null,"sortField":null,"settings":{"apiKey":"b0aed604-d757-4382-a232-bb84da1351ed","lang":"ru_RU","coordorder":"latlong","version":"2.1"}}
	const features = yajson.markers.map(({ coords, markerId, hintContent, address, phone, site, desc, color }) => {
		return {
			type: 'Feature',
			geometry: { type: 'Point', coordinates: coords.map(v => +v).reverse() }, // разные порядок (ГИП: Д/Ш, Яндекс: Ш/Д), и тип (ГИП: число, Яндекс: строка)
			properties: {
				markerId, hintContent, address, phone, site, desc, color
			},
		}
	})
	return {
		type: 'FeatureCollection',
		features,
		// crs: { type: 'name', 'properties': { name: 'urn:ogc:def:crs:EPSG::4326' } }
	} /* 'new_style0041', true // TODO создать и указать стиль в цветах РЖД, поиграть с true (редакт.) */
}



